import React from 'react';
import { Printer, ArrowLeft } from 'react-feather';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { intlShape } from 'react-intl';

import { Page, Row, Column } from 'components/shared/Layout';
import { bookingShape } from 'constants/propTypes';
import HideWhenPrinted from 'components/shared/HideWhenPrinted';
import { EUROSTAR } from 'types/constants';

import { StyledLinkButton, StyledH1 } from './styles';
import BookingDetails from './BookingDetails';
import JourneyDetails from './JourneyDetails';
import PaymentDetails from './PaymentDetails';
import PriceBreakdown from './PriceBreakdown';
import Copy from './Copy';
import { getQuoteConfirmationStatus } from './utils';

const QuoteConfirmation = ({ booking, intl }) => {
  const history = useHistory();
  const handleRedirect = () => history.push(`/manage/bookings/${booking.reference}/payments`);

  const quotationStatus = getQuoteConfirmationStatus(booking.status, booking.payments) ?? 'title';

  return (
    <Page>
      <Row span={14} start={2}>
        <Row alignItems="center">
          <Column span={14}>
            <HideWhenPrinted>
              <StyledLinkButton onClick={handleRedirect}>
                <ArrowLeft />
                <FormattedMessage id="quoteConfirmation.returnToPaymentsPage" />
              </StyledLinkButton>
            </HideWhenPrinted>
          </Column>
          <Column span={2} justifyContent="flex-end">
            <HideWhenPrinted>
              <StyledLinkButton onClick={window.print}>
                <Printer />
                <FormattedMessage id="quoteConfirmation.print" />
              </StyledLinkButton>
            </HideWhenPrinted>
          </Column>
        </Row>
        <StyledH1>
          <FormattedMessage
            id={`quoteConfirmation.${quotationStatus}`}
            values={{
              bookingReference: booking.reference,
              groupName: booking?.customer?.companyName ?? ''
            }}
          />
        </StyledH1>
        <BookingDetails booking={booking} />
        <JourneyDetails booking={booking} intl={intl} />
        <PaymentDetails intl={intl} booking={booking} />
        <PriceBreakdown booking={booking} intl={intl} />
        <Copy isExternalBooking={booking.salesChannelCode !== EUROSTAR} />
      </Row>
    </Page>
  );
};

QuoteConfirmation.propTypes = {
  booking: bookingShape.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(QuoteConfirmation);
